import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";
import { initConsent } from "./utils/consent";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Gallery from "./components/Gallery";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Location from "./components/Location";
import Footer from "./components/Footer";
import FAQ from "./components/FAQ";
import CookieConsent from "./components/CookieConsent";
import Chatbot from "./components/Chatbot";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import AdminContent from "./pages/AdminContent";
import AdminChangePassword from "./pages/AdminChangePassword";

initConsent();

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <Features />
      <Gallery />
      <Process />
      <Testimonials />
      <ContactForm />
      <FAQ />
      <Location />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/change-password" element={<AdminChangePassword />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
          <CookieConsent />
          <Chatbot />
        </BrowserRouter>
      </SiteProvider>
    </div>
  );
}

export default App;
